import { Component, ViewChild, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { compare } from 'fast-json-patch';


@Component({
  selector: 'app-wizardpage-step8-specialty',
  templateUrl: './wizardpage-step8.component.html',
  styleUrls: ['./wizardpage-step8.component.scss']
})
export class WizardpageStep8SpecialtyComponent implements OnInit {


  // tslint:disable-next-line:max-line-length
  @Output() continueevnt: EventEmitter<any> = new EventEmitter<any>(); // send event out to parent through emitter, then pass in event through function
  @Output() pagecountevnt: EventEmitter<number> = new EventEmitter<number>();

  isSubmitted = false;
  initForm: any;
  isfetching: boolean;

testnow: any[];
  constructor() { }

  @Input() regForm: UntypedFormGroup;



  ngOnInit(): void {

    this.initForm = this.regForm.value;
    this.isfetching = false;


    this.clinicClick(this.regForm.get('CLINIC').value);
    this.staffClick(this.regForm.get('OTHERSTAFF').value);


  }



 clinicClick(x) {


    const checked = x === null || x === '' ? false : x === 'Clinic' ? true : x.currentTarget.checked;

    if (checked === true) {
       this.regForm.get('CLINIC21').enable();
     } else {
       this.regForm.get('CLINIC21').disable();
       this.regForm.get('CLINIC21').setValue('');
     }

  }



  staffClick(x) {


    const checked = x === null || x === '' ? false : x === 'Other' ? true : x.currentTarget.checked;

    if (checked === true) {
       this.regForm.get('OTHERSTAFF2').enable();
     } else {
       this.regForm.get('OTHERSTAFF2').disable();
       this.regForm.get('OTHERSTAFF2').setValue('');
     }

  }




  decreasePage() {
    this.pagecountevnt.emit(0);
  }


  step8Submitted(postValue: UntypedFormGroup) {



    postValue.get('HC').setValue(postValue.get('HC').value === true ||
    postValue.get('HC').value === 'Home Care' ? 'Home Care' : '');

    postValue.get('EXTCARE').setValue(postValue.get('EXTCARE').value === true ||
     postValue.get('EXTCARE').value === 'Extended Care' ? 'Extended Care' : '');

    postValue.get('SURG').setValue(postValue.get('SURG').value === true ||
     postValue.get('SURG').value === 'Med./Surg' ? 'Med./Surg' : '');

    postValue.get('HOSPICE').setValue(postValue.get('HOSPICE').value === true ||
     postValue.get('HOSPICE').value === 'Hospice' ? 'Hospice' : '');

    postValue.get('MENTAL').setValue(postValue.get('MENTAL').value === true ||
     postValue.get('MENTAL').value === 'Mental Health' ? 'Mental Health' : '');

    postValue.get('INTCARE').setValue(postValue.get('INTCARE').value === true ||
     postValue.get('INTCARE').value === 'Intermittent Care' ? 'Intermittent Care' : '');

    postValue.get('ONCOLOGY').setValue(postValue.get('ONCOLOGY').value === true  ||
     postValue.get('ONCOLOGY').value === 'Oncology' ? 'Oncology' : '');

    postValue.get('IV').setValue(postValue.get('IV').value === true ||
     postValue.get('IV').value === 'IV Therapy' ? 'IV Therapy' : '');

    postValue.get('MATCHILD').setValue(postValue.get('MATCHILD').value === true ||
     postValue.get('MATCHILD').value === 'Maternal Child' ? 'Maternal Child' : '');

    postValue.get('RESIDENTIAL').setValue(postValue.get('RESIDENTIAL').value === true ||
     postValue.get('RESIDENTIAL').value === 'Residential Care' ? 'Residential Care' : '');

    postValue.get('STAFF').setValue(postValue.get('STAFF').value === true ||
     postValue.get('STAFF').value === 'Supplemental Staffing' ? 'Supplemental Staffing' : '');

    postValue.get('GENERIC').setValue(postValue.get('GENERIC').value === true ||
     postValue.get('GENERIC').value === 'Generic' ? 'Generic' : '');

    postValue.get('HOSPITAL').setValue(postValue.get('HOSPITAL').value === true ||
     postValue.get('HOSPITAL').value === 'Hospital' ? 'Hospital' : '');

    postValue.get('ICU').setValue(postValue.get('ICU').value === true ||
     postValue.get('ICU').value === 'ICU/CCU' ? 'ICU/CCU' : '');

    postValue.get('LABOR').setValue(postValue.get('LABOR').value === true ||
     postValue.get('LABOR').value === 'Labor/Delivery' ? 'Labor/Delivery' : '');

    postValue.get('MEDSURG').setValue(postValue.get('MEDSURG').value === true ||
     postValue.get('MEDSURG').value === 'Med./Surg.' ? 'Med./Surg.' : '');

    postValue.get('NURSING').setValue(postValue.get('NURSING').value === true ||
     postValue.get('NURSING').value === 'Nursing Home' ? 'Nursing Home' : '');

    postValue.get('PEDS').setValue(postValue.get('PEDS').value === true ||
     postValue.get('PEDS').value === 'Pediatric' ? 'Pediatric' : '');

    postValue.get('PRIVATE').setValue(postValue.get('PRIVATE').value === true ||
     postValue.get('PRIVATE').value === 'Private Duty' ? 'Private Duty' : '');

    postValue.get('PSYCH').setValue(postValue.get('PSYCH').value === true ||
     postValue.get('PSYCH').value === 'Psychiatric' ? 'Psychiatric' : '');

    postValue.get('CLINIC').setValue(postValue.get('CLINIC').value === true ||
     postValue.get('CLINIC').value === 'Clinic' ? 'Clinic' : '');

    postValue.get('OTHERSTAFF').setValue(postValue.get('OTHERSTAFF').value === true ||
     postValue.get('OTHERSTAFF').value === 'Other' ? 'Other' : '');




    const documentA = this.initForm;
    const documentB = postValue.value;



    const jsonpatchobject = compare(documentA, documentB);


    this.regForm.get('CLINIC21').markAsTouched();
    this.regForm.get('CLINIC21').updateValueAndValidity();
    this.regForm.get('OTHERSTAFF2').markAsTouched();
    this.regForm.get('OTHERSTAFF2').updateValueAndValidity();

    this.isSubmitted = true;
    if (!this.regForm.valid) {
      return false;
    } else {
      // the is the event property of the template emitting the validation value to the parent component

      this.isfetching = true;
      this.continueevnt.emit(jsonpatchobject);
      this.pagecountevnt.emit(1);

      return true;
    }

   }

   isFetching(e) {
    this.isfetching = e; }

}
